import React, { useState } from 'react';
import Authorization from '../common/Authorization';
import resetEmail from "../images/forgot_password.svg";
import api from '../../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [notification, setNotification] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await api.auth.forgotPassword(email);
      setEmail('');
      setNotification({
        message: data.message || "Forgot password email sent successfully.",
        type: "success",
      });
    } catch (error) {
      setNotification({
        message: `Error:`,
        type: "error",
      });
    }
  };

  return (
    <div className="flex h-screen bg-white">
      <Authorization />
      <div className="w-1/2 p-12 flex items-center justify-center">
        <div className="w-full max-w-md">
          <h2 className="text-3xl font-bold mb-6">Forgot Password</h2>
          <p className="mb-6 text-gray-600">Please enter email to reset the password</p>

          {notification && (
            <div
              className={`mb-4 p-3 rounded ${
                notification.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}
            >
              {notification.message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="flex items-center mb-2">
                <img src={resetEmail} alt="reset" />
                <span className="ml-2 text-blue-600 font-medium">Reset Via Email</span>
              </label>
              <p className="text-sm text-gray-500">Link will be sent to your Email Address</p>
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 mb-2" htmlFor="email">
                Enter Email
              </label>
              <input
                type="email"
                id="email"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Mani11@yopmail.com"
                required
              />
            </div>
            <div className="flex items-center justify-between">
              <button
                type="submit"
                className="bg-blue text-white px-6 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Submit
              </button>
              <a href="/login" className="text-blue-600 hover:underline">
                Go to Login
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
